import { h, Host, } from "@stencil/core";
/** @internal */
export class Backdrop {
    constructor() {
        this.onTransitionEnd = () => {
            switch (this.state) {
                case 'entering': {
                    this.state = 'entered';
                    break;
                }
                case 'exiting': {
                    this.resolveClose?.(true);
                    break;
                }
            }
        };
        this.onClickBackdrop = () => {
            this.requestClose.emit();
        };
        this.showBackdrop = false;
        this.preventOverscroll = false;
        this.child = null;
        this.state = 'mounting';
    }
    async renderNode(node) {
        this.child = node(h);
    }
    async close() {
        const closed = await new Promise((resolve) => {
            this.resolveClose = resolve;
            this.state = 'exiting';
        });
        delete this.resolveClose;
        return closed;
    }
    async cancelClose() {
        if (this.state !== 'exiting')
            return;
        this.resolveClose?.(false);
        this.state = 'entering';
    }
    componentDidLoad() {
        requestAnimationFrame(() => {
            this.state = 'entering';
        });
    }
    render() {
        return (h(Host, { key: '9b9fb57d43046c3b17d095fa41f20ba1ab6fc18b', onTransitionEnd: this.onTransitionEnd, class: this.state, style: {
                opacity: this.state === 'mounting' || this.state === 'exiting'
                    ? '0'
                    : '1',
            } }, this.showBackdrop && (h("div", { key: '5bcd8dd22e290fb5abc611df8a1318f1aa9aaa39', onClick: this.onClickBackdrop, class: 'backdrop' })), this.child));
    }
    static get is() { return "es-backdrop"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-backdrop.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-backdrop.css"]
        };
    }
    static get properties() {
        return {
            "showBackdrop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "show-backdrop",
                "reflect": false,
                "defaultValue": "false"
            },
            "preventOverscroll": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "prevent-overscroll",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "child": {},
            "state": {}
        };
    }
    static get events() {
        return [{
                "method": "requestClose",
                "name": "requestClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "closed",
                "name": "closed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "renderNode": {
                "complexType": {
                    "signature": "(node: RenderFunction) => Promise<void>",
                    "parameters": [{
                            "name": "node",
                            "type": "(h: typeof h) => string | VNode | VNode[] | null",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "RenderFunction": {
                            "location": "import",
                            "path": "../../../../types",
                            "id": "src/types.ts::RenderFunction"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<boolean>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<boolean>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "cancelClose": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=es-backdrop.js.map
